/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SkillsRouteImport } from './routes/skills'
import { Route as TriggerIndexRouteImport } from './routes/trigger/index'
import { Route as TasksIndexRouteImport } from './routes/tasks/index'
import { Route as SpotlightsIndexRouteImport } from './routes/spotlights/index'
import { Route as SkillsIndexRouteImport } from './routes/skills/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as QuickStartIndexRouteImport } from './routes/quick-start/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as CIndexRouteImport } from './routes/c/index'
import { Route as TasksTaskIdRouteImport } from './routes/tasks/$taskId'
import { Route as SkillsNewRouteImport } from './routes/skills/new'
import { Route as SkillsLibraryRouteImport } from './routes/skills/library'
import { Route as SkillsSkillRefRouteImport } from './routes/skills/$skillRef'
import { Route as SettingsUsageRouteImport } from './routes/settings/usage'
import { Route as SettingsToolsRouteImport } from './routes/settings/tools'
import { Route as SettingsRoiReportsRouteImport } from './routes/settings/roi-reports'
import { Route as SettingsPreferencesRouteImport } from './routes/settings/preferences'
import { Route as SettingsPleriSkillsRouteImport } from './routes/settings/pleri-skills'
import { Route as SettingsOrganizationUsageRouteImport } from './routes/settings/organization-usage'
import { Route as SettingsNotificationRouteImport } from './routes/settings/notification'
import { Route as SettingsMemoryRouteImport } from './routes/settings/memory'
import { Route as SettingsActivitiesRouteImport } from './routes/settings/activities'
import { Route as DashboardDashboardIdRouteImport } from './routes/dashboard/$dashboardId'
import { Route as CConversationIdRouteImport } from './routes/c/$conversationId'
import { Route as SettingsToolsIndexRouteImport } from './routes/settings/tools/index'
import { Route as SettingsRoiReportsIndexRouteImport } from './routes/settings/roi-reports/index'
import { Route as SettingsRoiReportsMonthRouteImport } from './routes/settings/roi-reports/$month'
import { Route as SettingsAboutYouQuestionsRouteImport } from './routes/settings/about-you/questions'
import { Route as TasksTaskIdExecutionConversationIdRouteImport } from './routes/tasks/$taskId/execution/$conversationId'
import { Route as SettingsToolsWorkspaceWorkspaceIdRouteImport } from './routes/settings/tools/workspace/$workspaceId'
import { Route as SettingsToolsSkillSkillIdRouteImport } from './routes/settings/tools/skill/$skillId'

const SkillsRoute = SkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const TriggerIndexRoute = TriggerIndexRouteImport.update({
  id: '/trigger/',
  path: '/trigger/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const SpotlightsIndexRoute = SpotlightsIndexRouteImport.update({
  id: '/spotlights/',
  path: '/spotlights/',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillsIndexRoute = SkillsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SkillsRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuickStartIndexRoute = QuickStartIndexRouteImport.update({
  id: '/quick-start/',
  path: '/quick-start/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const CIndexRoute = CIndexRouteImport.update({
  id: '/c/',
  path: '/c/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillsNewRoute = SkillsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SkillsRoute,
} as any)
const SkillsLibraryRoute = SkillsLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => SkillsRoute,
} as any)
const SkillsSkillRefRoute = SkillsSkillRefRouteImport.update({
  id: '/$skillRef',
  path: '/$skillRef',
  getParentRoute: () => SkillsRoute,
} as any)
const SettingsUsageRoute = SettingsUsageRouteImport.update({
  id: '/settings/usage',
  path: '/settings/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsToolsRoute = SettingsToolsRouteImport.update({
  id: '/settings/tools',
  path: '/settings/tools',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoiReportsRoute = SettingsRoiReportsRouteImport.update({
  id: '/settings/roi-reports',
  path: '/settings/roi-reports',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPreferencesRoute = SettingsPreferencesRouteImport.update({
  id: '/settings/preferences',
  path: '/settings/preferences',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPleriSkillsRoute = SettingsPleriSkillsRouteImport.update({
  id: '/settings/pleri-skills',
  path: '/settings/pleri-skills',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOrganizationUsageRoute =
  SettingsOrganizationUsageRouteImport.update({
    id: '/settings/organization-usage',
    path: '/settings/organization-usage',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsNotificationRoute = SettingsNotificationRouteImport.update({
  id: '/settings/notification',
  path: '/settings/notification',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMemoryRoute = SettingsMemoryRouteImport.update({
  id: '/settings/memory',
  path: '/settings/memory',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsActivitiesRoute = SettingsActivitiesRouteImport.update({
  id: '/settings/activities',
  path: '/settings/activities',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardDashboardIdRoute = DashboardDashboardIdRouteImport.update({
  id: '/dashboard/$dashboardId',
  path: '/dashboard/$dashboardId',
  getParentRoute: () => rootRouteImport,
} as any)
const CConversationIdRoute = CConversationIdRouteImport.update({
  id: '/c/$conversationId',
  path: '/c/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsToolsIndexRoute = SettingsToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsToolsRoute,
} as any)
const SettingsRoiReportsIndexRoute = SettingsRoiReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoiReportsRoute,
} as any)
const SettingsRoiReportsMonthRoute = SettingsRoiReportsMonthRouteImport.update({
  id: '/$month',
  path: '/$month',
  getParentRoute: () => SettingsRoiReportsRoute,
} as any)
const SettingsAboutYouQuestionsRoute =
  SettingsAboutYouQuestionsRouteImport.update({
    id: '/settings/about-you/questions',
    path: '/settings/about-you/questions',
    getParentRoute: () => rootRouteImport,
  } as any)
const TasksTaskIdExecutionConversationIdRoute =
  TasksTaskIdExecutionConversationIdRouteImport.update({
    id: '/execution/$conversationId',
    path: '/execution/$conversationId',
    getParentRoute: () => TasksTaskIdRoute,
  } as any)
const SettingsToolsWorkspaceWorkspaceIdRoute =
  SettingsToolsWorkspaceWorkspaceIdRouteImport.update({
    id: '/workspace/$workspaceId',
    path: '/workspace/$workspaceId',
    getParentRoute: () => SettingsToolsRoute,
  } as any)
const SettingsToolsSkillSkillIdRoute =
  SettingsToolsSkillSkillIdRouteImport.update({
    id: '/skill/$skillId',
    path: '/skill/$skillId',
    getParentRoute: () => SettingsToolsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/skills': typeof SkillsRouteWithChildren
  '/c/$conversationId': typeof CConversationIdRoute
  '/dashboard/$dashboardId': typeof DashboardDashboardIdRoute
  '/settings/activities': typeof SettingsActivitiesRoute
  '/settings/memory': typeof SettingsMemoryRoute
  '/settings/notification': typeof SettingsNotificationRoute
  '/settings/organization-usage': typeof SettingsOrganizationUsageRoute
  '/settings/pleri-skills': typeof SettingsPleriSkillsRoute
  '/settings/preferences': typeof SettingsPreferencesRoute
  '/settings/roi-reports': typeof SettingsRoiReportsRouteWithChildren
  '/settings/tools': typeof SettingsToolsRouteWithChildren
  '/settings/usage': typeof SettingsUsageRoute
  '/skills/$skillRef': typeof SkillsSkillRefRoute
  '/skills/library': typeof SkillsLibraryRoute
  '/skills/new': typeof SkillsNewRoute
  '/tasks/$taskId': typeof TasksTaskIdRouteWithChildren
  '/c/': typeof CIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/quick-start/': typeof QuickStartIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/skills/': typeof SkillsIndexRoute
  '/spotlights/': typeof SpotlightsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/trigger/': typeof TriggerIndexRoute
  '/settings/about-you/questions': typeof SettingsAboutYouQuestionsRoute
  '/settings/roi-reports/$month': typeof SettingsRoiReportsMonthRoute
  '/settings/roi-reports/': typeof SettingsRoiReportsIndexRoute
  '/settings/tools/': typeof SettingsToolsIndexRoute
  '/settings/tools/skill/$skillId': typeof SettingsToolsSkillSkillIdRoute
  '/settings/tools/workspace/$workspaceId': typeof SettingsToolsWorkspaceWorkspaceIdRoute
  '/tasks/$taskId/execution/$conversationId': typeof TasksTaskIdExecutionConversationIdRoute
}
export interface FileRoutesByTo {
  '/c/$conversationId': typeof CConversationIdRoute
  '/dashboard/$dashboardId': typeof DashboardDashboardIdRoute
  '/settings/activities': typeof SettingsActivitiesRoute
  '/settings/memory': typeof SettingsMemoryRoute
  '/settings/notification': typeof SettingsNotificationRoute
  '/settings/organization-usage': typeof SettingsOrganizationUsageRoute
  '/settings/pleri-skills': typeof SettingsPleriSkillsRoute
  '/settings/preferences': typeof SettingsPreferencesRoute
  '/settings/usage': typeof SettingsUsageRoute
  '/skills/$skillRef': typeof SkillsSkillRefRoute
  '/skills/library': typeof SkillsLibraryRoute
  '/skills/new': typeof SkillsNewRoute
  '/tasks/$taskId': typeof TasksTaskIdRouteWithChildren
  '/c': typeof CIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/quick-start': typeof QuickStartIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/skills': typeof SkillsIndexRoute
  '/spotlights': typeof SpotlightsIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/trigger': typeof TriggerIndexRoute
  '/settings/about-you/questions': typeof SettingsAboutYouQuestionsRoute
  '/settings/roi-reports/$month': typeof SettingsRoiReportsMonthRoute
  '/settings/roi-reports': typeof SettingsRoiReportsIndexRoute
  '/settings/tools': typeof SettingsToolsIndexRoute
  '/settings/tools/skill/$skillId': typeof SettingsToolsSkillSkillIdRoute
  '/settings/tools/workspace/$workspaceId': typeof SettingsToolsWorkspaceWorkspaceIdRoute
  '/tasks/$taskId/execution/$conversationId': typeof TasksTaskIdExecutionConversationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/skills': typeof SkillsRouteWithChildren
  '/c/$conversationId': typeof CConversationIdRoute
  '/dashboard/$dashboardId': typeof DashboardDashboardIdRoute
  '/settings/activities': typeof SettingsActivitiesRoute
  '/settings/memory': typeof SettingsMemoryRoute
  '/settings/notification': typeof SettingsNotificationRoute
  '/settings/organization-usage': typeof SettingsOrganizationUsageRoute
  '/settings/pleri-skills': typeof SettingsPleriSkillsRoute
  '/settings/preferences': typeof SettingsPreferencesRoute
  '/settings/roi-reports': typeof SettingsRoiReportsRouteWithChildren
  '/settings/tools': typeof SettingsToolsRouteWithChildren
  '/settings/usage': typeof SettingsUsageRoute
  '/skills/$skillRef': typeof SkillsSkillRefRoute
  '/skills/library': typeof SkillsLibraryRoute
  '/skills/new': typeof SkillsNewRoute
  '/tasks/$taskId': typeof TasksTaskIdRouteWithChildren
  '/c/': typeof CIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/quick-start/': typeof QuickStartIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/skills/': typeof SkillsIndexRoute
  '/spotlights/': typeof SpotlightsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/trigger/': typeof TriggerIndexRoute
  '/settings/about-you/questions': typeof SettingsAboutYouQuestionsRoute
  '/settings/roi-reports/$month': typeof SettingsRoiReportsMonthRoute
  '/settings/roi-reports/': typeof SettingsRoiReportsIndexRoute
  '/settings/tools/': typeof SettingsToolsIndexRoute
  '/settings/tools/skill/$skillId': typeof SettingsToolsSkillSkillIdRoute
  '/settings/tools/workspace/$workspaceId': typeof SettingsToolsWorkspaceWorkspaceIdRoute
  '/tasks/$taskId/execution/$conversationId': typeof TasksTaskIdExecutionConversationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/skills'
    | '/c/$conversationId'
    | '/dashboard/$dashboardId'
    | '/settings/activities'
    | '/settings/memory'
    | '/settings/notification'
    | '/settings/organization-usage'
    | '/settings/pleri-skills'
    | '/settings/preferences'
    | '/settings/roi-reports'
    | '/settings/tools'
    | '/settings/usage'
    | '/skills/$skillRef'
    | '/skills/library'
    | '/skills/new'
    | '/tasks/$taskId'
    | '/c/'
    | '/dashboard/'
    | '/onboarding/'
    | '/quick-start/'
    | '/settings/'
    | '/skills/'
    | '/spotlights/'
    | '/tasks/'
    | '/trigger/'
    | '/settings/about-you/questions'
    | '/settings/roi-reports/$month'
    | '/settings/roi-reports/'
    | '/settings/tools/'
    | '/settings/tools/skill/$skillId'
    | '/settings/tools/workspace/$workspaceId'
    | '/tasks/$taskId/execution/$conversationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/c/$conversationId'
    | '/dashboard/$dashboardId'
    | '/settings/activities'
    | '/settings/memory'
    | '/settings/notification'
    | '/settings/organization-usage'
    | '/settings/pleri-skills'
    | '/settings/preferences'
    | '/settings/usage'
    | '/skills/$skillRef'
    | '/skills/library'
    | '/skills/new'
    | '/tasks/$taskId'
    | '/c'
    | '/dashboard'
    | '/onboarding'
    | '/quick-start'
    | '/settings'
    | '/skills'
    | '/spotlights'
    | '/tasks'
    | '/trigger'
    | '/settings/about-you/questions'
    | '/settings/roi-reports/$month'
    | '/settings/roi-reports'
    | '/settings/tools'
    | '/settings/tools/skill/$skillId'
    | '/settings/tools/workspace/$workspaceId'
    | '/tasks/$taskId/execution/$conversationId'
  id:
    | '__root__'
    | '/skills'
    | '/c/$conversationId'
    | '/dashboard/$dashboardId'
    | '/settings/activities'
    | '/settings/memory'
    | '/settings/notification'
    | '/settings/organization-usage'
    | '/settings/pleri-skills'
    | '/settings/preferences'
    | '/settings/roi-reports'
    | '/settings/tools'
    | '/settings/usage'
    | '/skills/$skillRef'
    | '/skills/library'
    | '/skills/new'
    | '/tasks/$taskId'
    | '/c/'
    | '/dashboard/'
    | '/onboarding/'
    | '/quick-start/'
    | '/settings/'
    | '/skills/'
    | '/spotlights/'
    | '/tasks/'
    | '/trigger/'
    | '/settings/about-you/questions'
    | '/settings/roi-reports/$month'
    | '/settings/roi-reports/'
    | '/settings/tools/'
    | '/settings/tools/skill/$skillId'
    | '/settings/tools/workspace/$workspaceId'
    | '/tasks/$taskId/execution/$conversationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SkillsRoute: typeof SkillsRouteWithChildren
  CConversationIdRoute: typeof CConversationIdRoute
  DashboardDashboardIdRoute: typeof DashboardDashboardIdRoute
  SettingsActivitiesRoute: typeof SettingsActivitiesRoute
  SettingsMemoryRoute: typeof SettingsMemoryRoute
  SettingsNotificationRoute: typeof SettingsNotificationRoute
  SettingsOrganizationUsageRoute: typeof SettingsOrganizationUsageRoute
  SettingsPleriSkillsRoute: typeof SettingsPleriSkillsRoute
  SettingsPreferencesRoute: typeof SettingsPreferencesRoute
  SettingsRoiReportsRoute: typeof SettingsRoiReportsRouteWithChildren
  SettingsToolsRoute: typeof SettingsToolsRouteWithChildren
  SettingsUsageRoute: typeof SettingsUsageRoute
  TasksTaskIdRoute: typeof TasksTaskIdRouteWithChildren
  CIndexRoute: typeof CIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  QuickStartIndexRoute: typeof QuickStartIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SpotlightsIndexRoute: typeof SpotlightsIndexRoute
  TasksIndexRoute: typeof TasksIndexRoute
  TriggerIndexRoute: typeof TriggerIndexRoute
  SettingsAboutYouQuestionsRoute: typeof SettingsAboutYouQuestionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/skills': {
      id: '/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof SkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trigger/': {
      id: '/trigger/'
      path: '/trigger'
      fullPath: '/trigger/'
      preLoaderRoute: typeof TriggerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spotlights/': {
      id: '/spotlights/'
      path: '/spotlights'
      fullPath: '/spotlights/'
      preLoaderRoute: typeof SpotlightsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skills/': {
      id: '/skills/'
      path: '/'
      fullPath: '/skills/'
      preLoaderRoute: typeof SkillsIndexRouteImport
      parentRoute: typeof SkillsRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quick-start/': {
      id: '/quick-start/'
      path: '/quick-start'
      fullPath: '/quick-start/'
      preLoaderRoute: typeof QuickStartIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/': {
      id: '/c/'
      path: '/c'
      fullPath: '/c/'
      preLoaderRoute: typeof CIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skills/new': {
      id: '/skills/new'
      path: '/new'
      fullPath: '/skills/new'
      preLoaderRoute: typeof SkillsNewRouteImport
      parentRoute: typeof SkillsRoute
    }
    '/skills/library': {
      id: '/skills/library'
      path: '/library'
      fullPath: '/skills/library'
      preLoaderRoute: typeof SkillsLibraryRouteImport
      parentRoute: typeof SkillsRoute
    }
    '/skills/$skillRef': {
      id: '/skills/$skillRef'
      path: '/$skillRef'
      fullPath: '/skills/$skillRef'
      preLoaderRoute: typeof SkillsSkillRefRouteImport
      parentRoute: typeof SkillsRoute
    }
    '/settings/usage': {
      id: '/settings/usage'
      path: '/settings/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof SettingsUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tools': {
      id: '/settings/tools'
      path: '/settings/tools'
      fullPath: '/settings/tools'
      preLoaderRoute: typeof SettingsToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/roi-reports': {
      id: '/settings/roi-reports'
      path: '/settings/roi-reports'
      fullPath: '/settings/roi-reports'
      preLoaderRoute: typeof SettingsRoiReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/preferences': {
      id: '/settings/preferences'
      path: '/settings/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof SettingsPreferencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/pleri-skills': {
      id: '/settings/pleri-skills'
      path: '/settings/pleri-skills'
      fullPath: '/settings/pleri-skills'
      preLoaderRoute: typeof SettingsPleriSkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/organization-usage': {
      id: '/settings/organization-usage'
      path: '/settings/organization-usage'
      fullPath: '/settings/organization-usage'
      preLoaderRoute: typeof SettingsOrganizationUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notification': {
      id: '/settings/notification'
      path: '/settings/notification'
      fullPath: '/settings/notification'
      preLoaderRoute: typeof SettingsNotificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/memory': {
      id: '/settings/memory'
      path: '/settings/memory'
      fullPath: '/settings/memory'
      preLoaderRoute: typeof SettingsMemoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/activities': {
      id: '/settings/activities'
      path: '/settings/activities'
      fullPath: '/settings/activities'
      preLoaderRoute: typeof SettingsActivitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/$dashboardId': {
      id: '/dashboard/$dashboardId'
      path: '/dashboard/$dashboardId'
      fullPath: '/dashboard/$dashboardId'
      preLoaderRoute: typeof DashboardDashboardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$conversationId': {
      id: '/c/$conversationId'
      path: '/c/$conversationId'
      fullPath: '/c/$conversationId'
      preLoaderRoute: typeof CConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tools/': {
      id: '/settings/tools/'
      path: '/'
      fullPath: '/settings/tools/'
      preLoaderRoute: typeof SettingsToolsIndexRouteImport
      parentRoute: typeof SettingsToolsRoute
    }
    '/settings/roi-reports/': {
      id: '/settings/roi-reports/'
      path: '/'
      fullPath: '/settings/roi-reports/'
      preLoaderRoute: typeof SettingsRoiReportsIndexRouteImport
      parentRoute: typeof SettingsRoiReportsRoute
    }
    '/settings/roi-reports/$month': {
      id: '/settings/roi-reports/$month'
      path: '/$month'
      fullPath: '/settings/roi-reports/$month'
      preLoaderRoute: typeof SettingsRoiReportsMonthRouteImport
      parentRoute: typeof SettingsRoiReportsRoute
    }
    '/settings/about-you/questions': {
      id: '/settings/about-you/questions'
      path: '/settings/about-you/questions'
      fullPath: '/settings/about-you/questions'
      preLoaderRoute: typeof SettingsAboutYouQuestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId/execution/$conversationId': {
      id: '/tasks/$taskId/execution/$conversationId'
      path: '/execution/$conversationId'
      fullPath: '/tasks/$taskId/execution/$conversationId'
      preLoaderRoute: typeof TasksTaskIdExecutionConversationIdRouteImport
      parentRoute: typeof TasksTaskIdRoute
    }
    '/settings/tools/workspace/$workspaceId': {
      id: '/settings/tools/workspace/$workspaceId'
      path: '/workspace/$workspaceId'
      fullPath: '/settings/tools/workspace/$workspaceId'
      preLoaderRoute: typeof SettingsToolsWorkspaceWorkspaceIdRouteImport
      parentRoute: typeof SettingsToolsRoute
    }
    '/settings/tools/skill/$skillId': {
      id: '/settings/tools/skill/$skillId'
      path: '/skill/$skillId'
      fullPath: '/settings/tools/skill/$skillId'
      preLoaderRoute: typeof SettingsToolsSkillSkillIdRouteImport
      parentRoute: typeof SettingsToolsRoute
    }
  }
}

interface SkillsRouteChildren {
  SkillsSkillRefRoute: typeof SkillsSkillRefRoute
  SkillsLibraryRoute: typeof SkillsLibraryRoute
  SkillsNewRoute: typeof SkillsNewRoute
  SkillsIndexRoute: typeof SkillsIndexRoute
}

const SkillsRouteChildren: SkillsRouteChildren = {
  SkillsSkillRefRoute: SkillsSkillRefRoute,
  SkillsLibraryRoute: SkillsLibraryRoute,
  SkillsNewRoute: SkillsNewRoute,
  SkillsIndexRoute: SkillsIndexRoute,
}

const SkillsRouteWithChildren =
  SkillsRoute._addFileChildren(SkillsRouteChildren)

interface SettingsRoiReportsRouteChildren {
  SettingsRoiReportsMonthRoute: typeof SettingsRoiReportsMonthRoute
  SettingsRoiReportsIndexRoute: typeof SettingsRoiReportsIndexRoute
}

const SettingsRoiReportsRouteChildren: SettingsRoiReportsRouteChildren = {
  SettingsRoiReportsMonthRoute: SettingsRoiReportsMonthRoute,
  SettingsRoiReportsIndexRoute: SettingsRoiReportsIndexRoute,
}

const SettingsRoiReportsRouteWithChildren =
  SettingsRoiReportsRoute._addFileChildren(SettingsRoiReportsRouteChildren)

interface SettingsToolsRouteChildren {
  SettingsToolsIndexRoute: typeof SettingsToolsIndexRoute
  SettingsToolsSkillSkillIdRoute: typeof SettingsToolsSkillSkillIdRoute
  SettingsToolsWorkspaceWorkspaceIdRoute: typeof SettingsToolsWorkspaceWorkspaceIdRoute
}

const SettingsToolsRouteChildren: SettingsToolsRouteChildren = {
  SettingsToolsIndexRoute: SettingsToolsIndexRoute,
  SettingsToolsSkillSkillIdRoute: SettingsToolsSkillSkillIdRoute,
  SettingsToolsWorkspaceWorkspaceIdRoute:
    SettingsToolsWorkspaceWorkspaceIdRoute,
}

const SettingsToolsRouteWithChildren = SettingsToolsRoute._addFileChildren(
  SettingsToolsRouteChildren,
)

interface TasksTaskIdRouteChildren {
  TasksTaskIdExecutionConversationIdRoute: typeof TasksTaskIdExecutionConversationIdRoute
}

const TasksTaskIdRouteChildren: TasksTaskIdRouteChildren = {
  TasksTaskIdExecutionConversationIdRoute:
    TasksTaskIdExecutionConversationIdRoute,
}

const TasksTaskIdRouteWithChildren = TasksTaskIdRoute._addFileChildren(
  TasksTaskIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SkillsRoute: SkillsRouteWithChildren,
  CConversationIdRoute: CConversationIdRoute,
  DashboardDashboardIdRoute: DashboardDashboardIdRoute,
  SettingsActivitiesRoute: SettingsActivitiesRoute,
  SettingsMemoryRoute: SettingsMemoryRoute,
  SettingsNotificationRoute: SettingsNotificationRoute,
  SettingsOrganizationUsageRoute: SettingsOrganizationUsageRoute,
  SettingsPleriSkillsRoute: SettingsPleriSkillsRoute,
  SettingsPreferencesRoute: SettingsPreferencesRoute,
  SettingsRoiReportsRoute: SettingsRoiReportsRouteWithChildren,
  SettingsToolsRoute: SettingsToolsRouteWithChildren,
  SettingsUsageRoute: SettingsUsageRoute,
  TasksTaskIdRoute: TasksTaskIdRouteWithChildren,
  CIndexRoute: CIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  QuickStartIndexRoute: QuickStartIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SpotlightsIndexRoute: SpotlightsIndexRoute,
  TasksIndexRoute: TasksIndexRoute,
  TriggerIndexRoute: TriggerIndexRoute,
  SettingsAboutYouQuestionsRoute: SettingsAboutYouQuestionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
